<template>
  <div id="wrapper">
    <nav
      class="navbar navbar-default navbar-static-top"
      role="navigation"
      style="margin-bottom: 0"
    >
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle"
          data-toggle="collapse"
          data-target=".navbar-collapse"
        >
          <span class="sr-only">Навигационная панель</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <router-link to="/" class="navbar-brand">
          Электрон
        </router-link>
      </div>

      <ul class="nav navbar-top-links navbar-right">
        <li @click="signOut">
          <a>
            <i class="fa fa-sign-out fa-fw"></i> Выход
          </a>
        </li>
      </ul>

      <div class="navbar-default sidebar" role="navigation">
        <div class="sidebar-nav navbar-collapse">
          <ul class="nav" id="side-menu">
            <li>
              <router-link to="/main"> Главная </router-link>
            </li>
            <li>
              <a href="#">Склад<span class="fa arrow"></span></a>
              <ul class="nav nav-second-level">
                <li>
                  <router-link to="/peripherals">Периферия</router-link>
                </li>
                <li>
                  <router-link to="/details">Детали</router-link>
                </li>
                <li>
                  <router-link to="/circuit_boards">Платы</router-link>
                </li>
                <li>
                  <router-link to="/stock_movement">Движение по складу</router-link>
                </li>
                <li>
                  <router-link to="/inventory">Инвентаризация</router-link>
                </li>
              </ul>
            </li>
            <li>
              <router-link to="/projects">Проекты</router-link>
            </li>
            <li>
              <router-link to="/orders">Наряд-заказы</router-link>
            </li>
            <li>
              <router-link to="/users">Пользователи</router-link>
            </li>
            <li>
              <router-link to="/clients">Клиенты</router-link>
            </li>
            <li>
              <router-link to="/providers">Поставщики</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <router-view />
  </div>
</template>

<script>
import { useNotification } from '@/mixins';
export default {
  mixins: [
    useNotification,
  ],
  methods: {
    signOut() {
      localStorage.removeItem('token');
      this.showSuccessNotification('Вы покинули учетную запись');
      this.$router.push('/public/login');
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/layouts/DefaultLayout.vue